var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',_vm._b({class:['my-button', _vm.size, _vm.type]},'van-button',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }